<template>
    <div class="ascend-header-text">
        The Ascend Universe can unlock even more insight using the power of Experian's data.
        Here are the key features for each level of access:
    </div>
    <div class="ascend-cards-layout">
        <div class="ascend-card ascend-card-one">
            <div class="ascend-card1-inner">
                <div class="ascend-card1-header">
                    <span class="ascend-card1-title">EligibilityIQ</span>
                </div>
                <div class="ascend-card1-body">
                    <div class="ascend-card-points ascend-card-multiline">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Generic dashboards on eligibility performance.
                        </span>
                    </div>
                    <div class="ascend-card-points">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Enquires & click analysis.
                        </span>
                    </div>
                    <div class="ascend-card-points">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Customer profiling.
                        </span>
                    </div>
                    <div class="ascend-card-points">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Market trends.
                        </span>
                    </div>
                    <div class="ascend-card-points">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Poor group benchmarking.
                        </span>
                    </div>
                    <div class="ascend-card-points">
                        <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                        <span class="ascend-card-text">
                            Preapproval performance.
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="ascend-card ascend-card-two">
            <div class="ascend-card-shared-inner">
                <div class="ascend-card-shared-content">
                    <div class="ascend-card-shared-header">
                        <span class="ascend-card-shared-title">Ascend Market Insights (AMI)</span>
                    </div>
                    <div class="ascend-card-shared-body">

                        <div class="ascend-card-points ascend-card-multiline">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Bespoke dashboards on end-to-end customer performance.
                            </span>
                        </div>
                        <div class="ascend-card-points">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                CAIS analysis.
                            </span>
                        </div>
                        <div class="ascend-card-points ascend-card-multiline">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Customer performance after search & click.
                            </span>
                        </div>
                        <div class="ascend-card-points ascend-card-multiline">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Conversion analysis.
                            </span>
                        </div>
                    </div>
                </div>
                <button class="ascend-card-btn" @click="navigateToExternalLink('https://www.experian.co.uk/business/platforms/ascend/market-insights')">
                    <span>Learn more</span>
                    <svg class="ascend-card-btn-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 18l6-6-6-6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>


        <div class="ascend-card ascend-card-three">
            <div class="ascend-card-shared-inner">
                <div class="ascend-card-shared-content">
                    <div class="ascend-card-shared-header">
                        <span class="ascend-card-shared-title">Ascend Sandbox</span>
                    </div>
                    <div class="ascend-card-shared-body">
                        <div class="ascend-card-points ascend-card-multiline">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Full access to lender datasets within our sandbox platform.
                            </span>
                        </div>
                        <div class="ascend-card-points ascend-card-multiline">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Full anatomy on your own analysis and use cases.
                            </span>
                        </div>
                        <div class="ascend-card-points">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Lost opportunity analysis.
                            </span>
                        </div>
                        <div class="ascend-card-points">
                            <img class="ascend-verify-icon" :src="VerifyIcon" alt="ascend-verify-icon" />
                            <span class="ascend-card-text">
                                Ability to integrate your own datasets.
                            </span>
                        </div>
                    </div>
                </div>
                <button class="ascend-card-btn" @click="navigateToExternalLink('https://www.experian.co.uk/business/platforms/ascend/analytical')">
                    <span>Learn more</span>
                    <svg class="ascend-card-btn-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 18l6-6-6-6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import VerifyIcon from '@/assets/VerifyIcon.svg';

    function navigateToExternalLink(url) {
        window.open(url, '_blank'); 
    }

</script>

<style lang="scss" scoped>
    @import '../../styles/base';
    @import '../../../node_modules/hd-styles/modules/mixins';

    .ascend-header-text {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: center;
        width: 842px;
        height: 48px;
        margin-top: 32px;
        margin-bottom: 32px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        @include bp('small-medium') {
            width: 95vw;
            max-width: 100vw;
            font-size: 16px;
            height: auto;
            padding: 0 8px;
            box-sizing: border-box;
        }
    }

    .ascend-cards-layout {
        width: 1216px;
        height: 588px;
        display: flex;
        gap: 32px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;

        @include bp('small-medium') {
            flex-direction: column;
            align-items: center;
            gap: 24px;
            width: 100%;
            height: auto;
        }

        @include bp('medium-large') {
            flex-direction: row;
            gap: 32px;
            width: 100%;
            height: auto;
        }
    }

    .ascend-card {
        width: 384px;
        height: 588px;
        border-radius: 64px;
        border-width: 2px;
        border-style: solid;
        padding: 32px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        background: #fff;
        border-color: #E0E0E0;
    }

    .ascend-card-one {
        background: #FFF0FB;
        border: 2px solid #AF1685;
    }

    .ascend-card-points {
        display: flex;
        align-items: center;
        gap: 24px;
        width: 308px;
        height: 36px;
    }

    .ascend-card-multiline {
        height: 48px;
    }

    .ascend-verify-icon {
        width: 36px;
        height: 36px;
        flex-shrink: 0;
    }

    .ascend-card-text {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0px;
        color: #252C34;
        width: 252px;
        height: 36px;
        display: flex;
        align-items: center;
    }

    .ascend-card-multiline .ascend-card-text {
        height: 48px;
    }

    .ascend-card1-inner {
        width: 320px;
        height: 464px;
        display: flex;
        flex-direction: column;
        gap: 36px;
    }

    .ascend-card1-header {
        width: 320px;
        height: 80px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .ascend-card1-title {
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        text-align: center;
        color: #252C34;
        width: 314px;
        height: 80px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .ascend-card1-body {
        width: 308px;
        height: 348px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .ascend-card-two {
        background: #FEF2FF;
        border: 2px solid #883B92;
    }

    .ascend-card-shared-inner {
        width: 320px;
        height: 524px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .ascend-card-shared-content {
        width: 320px;
        height: 356px;
        display: flex;
        flex-direction: column;
        gap: 36px;
    }

    .ascend-card-shared-header {
        width: 320px;
        height: 80px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .ascend-card-shared-title {
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        text-align: center;
        color: #252C34;
        width: 314px;
        height: 80px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .ascend-card-shared-body {
        width: 308px;
        height: 240px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .ascend-card-btn {
        width: 320px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: none;
        border-radius: 4px;
        background: #426DA9;
        color: #fff;
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        padding: 7px 16px;
        cursor: pointer;
        transition: background 0.2s;
    }

    .ascend-card-btn-icon {
        margin-left: 8px;
        display: inline-block;
        vertical-align: middle;
    }

    .ascend-card-three {
        background: #F2F8FF;
        border: 2px solid #426DA9;
    }
</style>
